import { WorkspaceLimitsDc } from "@evergis/api";
import { useState } from "react";

import { isInfinityLimit } from "../../../../hooks/useLimitsExceededCheck";

interface ResourcesLimitsResponse {
  tablesTotalCount: number;
  setTablesTotalCount: (state: number) => void;
  layersTotalCount: number;
  setLayersTotalCount: (state: number) => void;
  isInitialTablesLimit: boolean;
  isInitialLayersLimit: boolean;
  isTablesLimitExceeded: boolean;
  isLayersLimitExceeded: boolean;
}

export const useResourcesLimits = (limits?: WorkspaceLimitsDc): ResourcesLimitsResponse => {
  const [tablesTotalCount, setTablesTotalCount] = useState<number>(0);
  const [layersTotalCount, setLayersTotalCount] = useState<number>(0);

  const isInitialTablesLimit: boolean =
    limits && (isInfinityLimit(limits.maxTablesCount) ? false : limits.currentTableCount >= limits.maxTablesCount);
  const isInitialLayersLimit: boolean =
    limits &&
    (isInfinityLimit(limits.maxServicesCount) ? false : limits.currentServiceCount >= limits.maxServicesCount);
  const isTablesLimitExceeded: boolean =
    limits && (isInfinityLimit(limits.maxTablesCount) ? false : tablesTotalCount > limits.maxTablesCount);
  const isLayersLimitExceeded: boolean =
    limits && (isInfinityLimit(limits.maxServicesCount) ? false : layersTotalCount > limits.maxServicesCount);

  return {
    tablesTotalCount,
    setTablesTotalCount,
    layersTotalCount,
    setLayersTotalCount,
    isInitialTablesLimit,
    isInitialLayersLimit,
    isTablesLimitExceeded,
    isLayersLimitExceeded,
  };
};
